import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UtilsService } from '../../services/utils.service';
import { Router } from '@angular/router';
import { PageTitleService } from '../../services/page-title.service';

@Component({
    selector: 'app-page-title',
    templateUrl: './page-title.component.html',
    styleUrls: ['./page-title.component.scss'],
    standalone: false
})
export class PageTitleComponent implements OnInit {
  constructor(
    public utilsService: UtilsService,
    private router: Router,
    private pageTitleService: PageTitleService
  ) {}
  @Input('title') title: string[] = [];
  @Input('route') route: string = '';
  @Input('description') description: string = '';
  @Input('tooltip') tooltip: string = '';
  @Input('showRefreshIcon') showRefresh: boolean = false;
  @Input() showUserGuide: boolean = false;
  @Input() pdfDoc: string = '';
  @Input() pdfLabel: string = 'User Guide';
  @Input() pdfTitle: string = 'View Guide';
  @Output() refreshPage = new EventEmitter<any>();

  ngOnInit(): void {}

  fnRefreshPage() {
    this.pageTitleService.fnIconRotate();
    const url = this.router.url;
    const tokens = url.split('/');
    const lastToken = tokens[tokens.length - 1];
    this.pageTitleService.fnRefreshTable(lastToken);
  }

  fnOpenPdf() {
    window.open(this.pdfDoc, '_blank');
  }
}
